<template>
  <v-layout>
    <v-flex v-if="driverAutos.length" xs12>
      <v-data-table
        :items="driverAutos"
        :items-per-page="-1"
        hide-default-header
        hide-default-footer
      >
        <template #header>
          <thead class="v-data-table-header">
            <tr>
              <th v-if="$can('driver_show_button_delete_auto')" />
              <th>{{ $t('common.number') }}</th>
              <th>{{ $t('common.fields.selectAuto') }}</th>
              <th>{{ $t('common.table.created') }}</th>
              <th>{{ $t('driversList.tableHeaders.qty_days') }}</th>
              <th>{{ $t('common.docs') }}</th>
            </tr>
          </thead>
        </template>

        <template #body="{ items }">
          <tbody>
            <tr v-for="(item, key) in items" :key="key">
              <td v-if="$can('driver_show_button_delete_auto')">
                <v-btn color="red" icon @click="removeAuto(item.id)">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </td>
              <td>{{ item.num }}</td>
              <td>{{ item.title }}</td>
              <td>{{ item.createdAt }}</td>
              <td>{{ item.qty_days_on_line }}</td>
              <td class="py-1">
                <v-flex>
                  <v-icon size="20" class="mb-1 mr-1">insert_drive_file</v-icon>
                  <a :href="item.url">{{
                    $t('common.btns.loadRentContract')
                  }}</a>
                </v-flex>
                <v-flex>
                  <v-icon size="20" class="mb-1 mr-1"
                    >mdi-file-certificate</v-icon
                  >
                  <a :href="item.transfer_car_act">{{
                    $t('common.btns.loadAcceptanceCertificate')
                  }}</a>
                </v-flex>
                <v-flex>
                  <v-icon size="20" class="mb-1 mr-1">mdi-file-send</v-icon>
                  <a :href="item.road_list">{{
                    $t('common.btns.loadWaybill')
                  }}</a>
                </v-flex>
                <v-flex>
                  <v-icon size="20" class="mb-1 mr-1">mdi-file-account</v-icon>
                  <a :href="item.car_acceptance_act">{{
                    $t('common.btns.loadAct')
                  }}</a>
                </v-flex>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-flex>
    <v-layout wrap>
      <v-flex v-if="!driverAutos.length" xs12>
        {{ $t('driverAutos.addAutoText') }}
      </v-flex>
      <v-flex v-if="!driverAutos.length" xs12>
        {{ $t('driverAutos.loadRentDocumentText') }}
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'DriverAutos',
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      driverAutos: 'driver/getDriverAutos',
    }),
  },
  methods: {
    ...mapActions({
      fetchDriverAvailableAutos: 'driver/fetchDriverAvailableAutos',
    }),
    ...mapMutations({
      setDriverAvailableAutos: 'driver/setDriverAvailableAutos',
      setDriverDeleteAuto: 'driver/setDriverDeleteAuto',
      setDeleteDriverAutoDialogState: 'driver/setDeleteDriverAutoDialogState',
    }),
    removeAuto(autoId) {
      this.setDriverDeleteAuto({ id: autoId });
      this.setDeleteDriverAutoDialogState(true);
    },
  },
};
</script>

<style lang="scss">
.created-at {
  font-size: 14px;
  color: #777;
  padding-left: 17px;
}

.v-data-footer {
  .v-btn--icon {
    text-decoration: none !important;
  }
}
</style>
